import { UIComponentHandler, UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel } from '../../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../../toolkit/uicomponentcss';
import { RepeatCardViewImpl } from './repeatcardview';
import { RepeatCardCSSStyle, RepeatCardCSSStyleImpl } from './repeatcardcss';

export interface RepeatCardComponentProps extends UIComponentProps
{
   title :string;
   isSelected:boolean;
   cssStyle:RepeatCardCSSStyle;
}

export interface RepeatCardComponentHandler extends UIComponentHandler
{

}

export class RepeatCardComponent extends UIComponentImpl<RepeatCardComponentProps, UIComponentState, UIDataModel>
{
    constructor(props: RepeatCardComponentProps)
    {
        super(props);

    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new RepeatCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new RepeatCardCSSStyleImpl(applicationContext);
    }

     

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/repeatcard/repeatcardcomponent.tsx